import { render, staticRenderFns } from "./TeacherValue.vue?vue&type=template&id=1997375b"
import script from "./TeacherValue.vue?vue&type=script&lang=js"
export * from "./TeacherValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-f8ff0a7f65/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports